import React, { useCallback } from 'react';

import Button from '@atlaskit/button';
import { openRemoveUsersMappingDialog } from 'src/services/mappedUsers';

import { trackEvent } from 'src/lib/analytics';

const UnlinkUsersButton = ({ id, analyticsEvent }) => {
  const onClick = useCallback((e) => {
    e.preventDefault();
    trackEvent(analyticsEvent, { label: 'unlink' });
    openRemoveUsersMappingDialog(id);
  }, [analyticsEvent, id]);

  return (
    <Button onClick={onClick} appearance="link">
      Unlink...
    </Button>
  );
};

export default UnlinkUsersButton;
